"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssociatedTokenAddressSync = exports.createAssociatedTokenAccountInstruction = exports.getZebecConnectionProvider = exports.getAnchorProvider = exports.parseDepositEvent = exports.parseQuoteInfo = exports.percentToBps = exports.getMintDecimals = void 0;
const assert_1 = __importDefault(require("assert"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const anchor_1 = require("@coral-xyz/anchor");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("./constants");
const provider_1 = require("./provider");
/**
 * Gets decimals for given mint
 * @param connection
 * @param mint
 * @returns
 */
function getMintDecimals(connection, mint) {
    return __awaiter(this, void 0, void 0, function* () {
        const info = yield connection.getTokenSupply(mint);
        return info.value.decimals;
    });
}
exports.getMintDecimals = getMintDecimals;
/**
 * Converts percentage value to bps
 * @param percent
 * @returns
 */
function percentToBps(percent) {
    return (0, bignumber_js_1.default)(percent).times(100).toFixed();
}
exports.percentToBps = percentToBps;
/**
 * Parse jupiter quote response
 * @param connection
 * @param quoteInfo
 * @returns
 */
function parseQuoteInfo(connection, quoteInfo) {
    return __awaiter(this, void 0, void 0, function* () {
        if (quoteInfo.error) {
            return {
                error: quoteInfo.error,
            };
        }
        const routePlan = quoteInfo.routePlan;
        (0, assert_1.default)(Array.isArray(routePlan));
        const routeInfos = yield Promise.all(routePlan.map((r) => __awaiter(this, void 0, void 0, function* () {
            const inDecimals = yield getMintDecimals(connection, new web3_js_1.PublicKey(r.swapInfo.inputMint));
            const inAmount = (0, bignumber_js_1.default)(r.swapInfo.inAmount).div(constants_1.TEN_BIGNUM.pow(inDecimals)).toFixed();
            const outDecimals = yield getMintDecimals(connection, new web3_js_1.PublicKey(r.swapInfo.outputMint));
            const outAmount = (0, bignumber_js_1.default)(r.swapInfo.outAmount).div(constants_1.TEN_BIGNUM.pow(outDecimals)).toFixed();
            return {
                percent: r.percent,
                swapInfo: {
                    ammKey: r.swapInfo.ammKey,
                    feeAmount: r.swapInfo.feeAmount,
                    feeMint: r.swapInfo.feeMint,
                    inAmount,
                    inputMint: r.swapInfo.inputMint,
                    label: r.swapInfo.label,
                    outAmount,
                    outputMint: r.swapInfo.outputMint,
                },
            };
        })));
        const outMintDecimals = yield getMintDecimals(connection, new web3_js_1.PublicKey(quoteInfo.outputMint));
        const outAmount = (0, bignumber_js_1.default)(quoteInfo.outAmount).div(constants_1.TEN_BIGNUM.pow(outMintDecimals)).toFixed();
        const inputMintDecimals = yield getMintDecimals(connection, new web3_js_1.PublicKey(quoteInfo.inputMint));
        const inAmount = (0, bignumber_js_1.default)(quoteInfo.inAmount).div(constants_1.TEN_BIGNUM.pow(inputMintDecimals)).toFixed();
        const otherAmountThreshold = quoteInfo.swapMode === "ExactIn"
            ? (0, bignumber_js_1.default)(quoteInfo.otherAmountThreshold).div(constants_1.TEN_BIGNUM.pow(outMintDecimals)).toFixed()
            : (0, bignumber_js_1.default)(quoteInfo.otherAmountThreshold).div(constants_1.TEN_BIGNUM.pow(inputMintDecimals)).toFixed();
        return {
            inputMint: quoteInfo.inputMint,
            inAmount,
            outputMint: quoteInfo.outputMint,
            outAmount,
            otherAmountThreshold,
            swapMode: quoteInfo.swapMode,
            slippageBps: quoteInfo.slippageBps,
            platformFee: quoteInfo.platformFee,
            priceImpactPct: quoteInfo.priceImpactPct,
            routePlan: routeInfos,
            contextSlot: quoteInfo.contextSlot,
            timeTaken: quoteInfo.timeTaken,
        };
    });
}
exports.parseQuoteInfo = parseQuoteInfo;
/**
 * Parse deposit event
 * @param event
 * @returns
 */
function parseDepositEvent(event) {
    const amount = (0, bignumber_js_1.default)(event.amount.toString()).div(constants_1.TEN_BIGNUM.pow(constants_1.USDC_DECIMALS)).toFixed();
    return {
        amount,
        cardType: event.cardType,
        from: event.from.toString(),
        index: event.index.toString(),
        to: event.to.toString(),
        tokenType: event.tokenType,
    };
}
exports.parseDepositEvent = parseDepositEvent;
/**
 * Create anchor provider
 * @param connection Solana web3 connection
 * @param wallet Anchor wallet
 * @param opts Confirm options
 *
 * @example
 * ```
 * const connection = new Connection(process.env.RPC_URL || clusterApiUrl("mainnet-beta"))
 * const wallet = useWallet();
 * const provider = getAnchorProvider(connection, wallet);
 * ```
 */
function getAnchorProvider(connection, wallet, opts) {
    const provider = new anchor_1.AnchorProvider(connection, wallet, opts);
    return provider;
}
exports.getAnchorProvider = getAnchorProvider;
/**
 * Create Zebec Connection Provider. Can we used for readonly operation to solana program
 * @param connection Solana web3 connection
 * @returns
 */
function getZebecConnectionProvider(connection) {
    return new provider_1.ZebecConnectionProvider(connection);
}
exports.getZebecConnectionProvider = getZebecConnectionProvider;
/**
 * Construct a CreateAssociatedTokenAccount instruction
 *
 * @param payer                    Payer of the initialization fees
 * @param associatedToken          New associated token account
 * @param owner                    Owner of the new account
 * @param mint                     Token mint account
 * @param programId                SPL Token program account
 * @param associatedTokenProgramId SPL Associated Token program account
 *
 * @return Instruction to add to a transaction
 */
function createAssociatedTokenAccountInstruction(payer, associatedToken, owner, mint, programId = constants_1.TOKEN_PROGRAM_ID, associatedTokenProgramId = constants_1.ASSOCIATED_TOKEN_PROGRAM_ID) {
    const keys = [
        { pubkey: payer, isSigner: true, isWritable: true },
        { pubkey: associatedToken, isSigner: false, isWritable: true },
        { pubkey: owner, isSigner: false, isWritable: false },
        { pubkey: mint, isSigner: false, isWritable: false },
        { pubkey: web3_js_1.SystemProgram.programId, isSigner: false, isWritable: false },
        { pubkey: programId, isSigner: false, isWritable: false },
    ];
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: associatedTokenProgramId,
        data: Buffer.alloc(0),
    });
}
exports.createAssociatedTokenAccountInstruction = createAssociatedTokenAccountInstruction;
/**
 * Get the address of the associated token account for a given mint and owner
 *
 * @param mint                     Token mint account
 * @param owner                    Owner of the new account
 * @param allowOwnerOffCurve       Allow the owner account to be a PDA (Program Derived Address)
 * @param programId                SPL Token program account
 * @param associatedTokenProgramId SPL Associated Token program account
 *
 * @return Address of the associated token account
 */
function getAssociatedTokenAddressSync(mint, owner, allowOwnerOffCurve = false, programId = constants_1.TOKEN_PROGRAM_ID, associatedTokenProgramId = constants_1.ASSOCIATED_TOKEN_PROGRAM_ID) {
    if (!allowOwnerOffCurve && !web3_js_1.PublicKey.isOnCurve(owner.toBuffer()))
        throw new Error("Token owner is off curve.");
    const [address] = web3_js_1.PublicKey.findProgramAddressSync([owner.toBuffer(), programId.toBuffer(), mint.toBuffer()], associatedTokenProgramId);
    return address;
}
exports.getAssociatedTokenAddressSync = getAssociatedTokenAddressSync;
